const isDevelopment = process.env.NODE_ENV === 'development';

const API_BASE_URL_DEV = 'http://localhost:8080';
const API_BASE_URL_PROD = process.env.NEXT_PUBLIC_API_BASE_URL || 'https://api.dev.swiftcns.ai';

export const API_BASE_URL = isDevelopment ? API_BASE_URL_DEV : API_BASE_URL_PROD;

// Specific base paths for different endpoint categories
export const CNS_API_BASE = `${API_BASE_URL}/cns/v1`;
export const AUTH_API_BASE = `${API_BASE_URL}/auth/v1`;
export const SIGNUP_API_BASE = `${API_BASE_URL}/signup/v1`;
export const ADMIN_API_BASE = `${API_BASE_URL}/admin/v1`;

// Swift CNS website URL (e.g. logout redirect, future links to main site)
export const SWIFTCNS_WEBSITE_URL = 'https://swiftcns.ai';

// Google Tag Manager Configuration (GA4 managed via GTM)
export const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID || 'GTM-TSW966FK'; 